module.exports = __webpack_public_path__ + "static/media/Standard Seat Set.e42d9fd5.png";